import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueQuillEditor from 'vue-quill-editor'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css';
import axios from 'axios'
import md5 from 'blueimp-md5'
import qs from 'qs'
import Lockr from 'lockr'
import moment from "moment"
import _ from 'lodash'
// import echarts from 'echarts'
import _g from './assets/js/global';
import api from './assets/js/http';
import Print from './assets/js/print';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import {
    checkPermission
} from './assets/js/util'
import {
    Message
} from 'element-ui'
import Watermark from './assets/js/waterMark';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as echarts from 'echarts'
import PinyinMatch from 'pinyin-match'
Vue.prototype.$echarts = echarts
Vue.prototype.$PinyinMatch = PinyinMatch
import store from './store/index.js'



Vue.prototype.checkPermission = checkPermission
// 本地环境
// axios.defaults.baseURL = 'http://172.17.10.184:3022/bs/'
// axios.defaults.baseURL = 'http://172.17.10.220:3022/bs/'

//测试域名
// axios.defaults.baseURL = 'https://hpamtt.bsl-lj.com/bs/'
axios.defaults.baseURL = 'https://hpapi.bosili.cn/bs/'
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.headers.token = Lockr.get('yyToken')
axios.defaults.timeout = 1000 * 60 * 3
axios.interceptors.request.use(function (config) {
    /*config.data = qs.stringify(config.data)*/
    return config;
}, function (err) {
    return Promise.reject(err);
});
import versionTood from './assets/js/versionUpdate'

router.beforeEach((to, from, next) => {
    var token = Lockr.get('yyToken')
    if (!token && to.path !== '/login') {
        Message.error({
            message: '登录超时,请重新登录!'
        });
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        })
    }
    next()
    //判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新
    // versionTood.isNewVersion();
})
// 浏览器关闭清除token
// window.addEventListener("beforeunload", function() { //这个方法是监测浏览器窗口发生变化的时候执行
//     // Lockr.flush()
//     // router.push('/login')
// });


router.afterEach((to) => {
    /* 路由发生变化修改页面title */
    // if (to.meta.title) {
    //   changTitle(to.meta.title);
    // }
    //年
    let year = new Date().getFullYear();
    //月份是从0月开始获取的，所以要+1;
    let month = new Date().getMonth() + 1;
    //日
    let day = new Date().getDate();
    let time = year + '.' + month + '.' + day
    if (to.path !== '/login') {
        let userName = Lockr.get("userName");
        Watermark.set(userName + time);
    }
});

Vue.config.productionTip = false
Vue.use(Viewer);

Vue.use(ElementUI);
Vue.use(VueQuillEditor)
Vue.use(Print)
window.axios = axios
window.Lockr = Lockr
window.md5 = md5
window.api = api
window.echarts = echarts
window.router = router
window.moment = moment
window.bus = new Vue()
window._ = _
window._g = _g
// window.exportUrl = 'http://172.17.10.220:9000/bs/'
window.exportUrl = 'https://hpamtt.bsl-lj.com/bs/'

//https://bskt.bsl-lj.com/bs/   https://bsk.bsl-lj.com/bs/ http://172.17.10.220:9000/bs/
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')